import "./FundingSolutions.module.css";
import Header from "@/reusable_sections/Header";
import CapitalAccess from "./sections/CapitalAccess";
import FundingTiers from "./sections/FundingTiers";
import Footer from "@/reusable_sections/Footer";
export default function FundingSolutionsPage() {
  return <div>
      <Header />
      <CapitalAccess />
      <FundingTiers />
      <Footer />
    </div>;
}